/*
********************************************************************************
- Archivo : client/src/components/Header/UserHeader.js
- Proyecto: CB30
- Módulo  : Encabezado de Usuario
-
- Propósito:
- Barra principal de navegación para usuarios del sistema.
-
- Funcionalidad:
- Presenta las opciones disponibles según el estado de validación del usuario.
- Permite acceder a encuestas, perfil y completar datos personales.
- Gestiona el cierre de sesión.
********************************************************************************
*/


import React from "react";
import { graphql, withApollo } from "react-apollo";
import { Link } from "react-router-dom";
import logoHorizontal from "../../images/logo-horizontal.png";
import DynamicMenu from "./DynamicMenu";


//Query
import query from "../../queries/fetchUser";

// Icons
import ExitIco from "react-icons/lib/ti/arrow-forward";

const UserHeader = props => {
  const handleLogout = async e => {
    e.preventDefault();
    try {
      await fetch('/logout', { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' } });
    } catch (err) {
      // ignore
    }
    if (props.client && props.client.resetStore) {
      try { await props.client.resetStore(); } catch (_) {}
    }
    window.location.assign('/login');
  };
  const isUserValidated = valid => {
    if (valid) {
      return (
        <React.Fragment>
          <ul className="nav nav-pills mr-auto">

            <DynamicMenu user={props.data.user} />
            
          </ul>
          <div className="my-2 my-md-0 text-white">
            <span className="badge badge-success">Usuario validado</span>
            <span className="px-2">
              Hola, {props.data.user.nombre} | Créditos:{" "}
              {props.data.user.surveys.length}
            </span>
            <button onClick={handleLogout} className="btn btn-outline-warning btn-sm">
              Salir <ExitIco />
            </button>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <Link to="/dashboard/perfil/editar" className="nav-link">
              Perfil
            </Link>
          </li>
        </ul>
        <div className="my-2 my-md-0 text-white">
          <Link
            to="/dashboard/perfil/agregar/detalles"
            className="btn btn-warning mx-2"
          >
            Agregar detalles a tu perfil
          </Link>
          <button onClick={handleLogout} className="btn btn-outline-warning">
            Salir <ExitIco />
          </button>
        </div>
      </React.Fragment>
    );
  };

  if (props.data.loading) {
    return <nav className="navbar navbar-expand-lg navbar-dark bg-dark" />;
  }

  
  if (props.data.user) {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark mb-4">
        <div className="container">
          <Link className="navbar-brand" to="/dashboard">
            <img src={logoHorizontal} alt="logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExample04"
            aria-controls="navbarsExample04"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarsExample04">
            {isUserValidated(props.data.user.validated)}
          </div>
        </div>
      </nav>
    );
  }
  return <div>Refresque el navegador...</div>;
};

export default withApollo(
  graphql(query, {
    options: { fetchPolicy: 'network-only' }
  })(UserHeader)
);



// WEBPACK FOOTER //
// ./src/components/Header/UserHeader.js